<!-- 学习班 添加 -->
<template>
  <div class="form_box">
    <div class="form_box__header">
      <AppPageHeader></AppPageHeader>
    </div>
    <el-card class="box-card mt-1">


      <!-- 第一部分，说明 -->

      <!-- 第三部分，确定 -->
      <el-row>
          <b class="font_base">补充学时说明</b>        
      </el-row>
      <el-row>
        <p class="f">1. 管理员可使用。局系统在职在编人员参加 <el-popover
          placement="top-start"
          width="600"
          trigger="hover">
          <p>1.学时数标准：按1天8学时、半天4学时折算，不足半天的按照40分钟1学时计算。</p>
          <p>2.脱产培训类型：市体育局及以上单位举办的党务培训、干部培训以及业务条线培训（未在党校微课堂设置课程的），如市委党校干部培训、市级机关党务培训、各类信息员培训；各直属单位举办的各类学习教育培训活动，如：党工团培训（主题党日、组织生活、参观、交流、学习、讨论、活动等）、中心组学习、专题讲座报告等；专技干部参加专技系列的继续教育培训，按照业务主管部门的学时数计入；其他规定范围内的教育培训。</p>
          <el-button slot="reference"  type="text">各类脱产培训</el-button>
        </el-popover> ，可由此补充导入。</p>
        <p class="f">2. 管理员通过上传 excel 的方式，导入补充学时信息（点击下载<a class="a-b" :href="attachmentUrl" target="_blank">补充学时模板</a>）。</p>
        <p class="f">3. excel的字段包括： 姓名、复兴壹号注册手机、补充学时、说明。<b>注册手机与姓名，需与复兴壹号内一致。</b></p>
        <p class="f">4. 重复的姓名 + 学时 + 说明 的数据不会重复录入。</p>
      </el-row>

      <!-- 第二部分，上传 -->
      <el-row class="mt-2">
          <b class="font_base">1. 上传补充学时文件</b>        
      </el-row>
      <el-row class="mt-1">
        <el-upload
          class="upload-demo"
          drag
          action="/api/manager/t-supplement-score/read"
          :before-upload="onBeforeUpload"
          :on-success="onUploadSuccess"
          multiple>
          <i class="el-icon-upload"></i>
          <div class="el-upload__text">将文件拖到此处，或<em>点击上传</em></div>
          <div class="el-upload__tip" slot="tip">只能上传excel文件，请按学时模板添加</div>
        </el-upload>
      </el-row>

      <!-- 第三部分，确定 -->
      <el-row class="mt-2">
          <b class="font_base">2. 确认补充学时信息</b>        
      </el-row>

      <el-row v-if="datas && datas.length > 0">
        <el-table
          :data="datas"
          style="width: 100%">
          <el-table-column
            type="index"
            width="50">
          </el-table-column>
          <el-table-column
            prop="name"
            label="学员名"
            width="100">
          </el-table-column>
          <el-table-column
            prop="phone"
            label="绑定手机"
            width="150">
          </el-table-column>
          <el-table-column
            prop="hour"
            label="补充学时数"
            width="100">
          </el-table-column>
          <el-table-column
            prop="comment"
            label="说明">
          </el-table-column>
          <el-table-column
            prop="dateStr"
            label="所属年月">
          </el-table-column>
          <el-table-column
            label="是否可导入"
            width="200">
            <template slot-scope="scope">
              <template v-if="scope.row.status == 0">
                <el-tag type="success">可导入</el-tag>
              </template>
              <template v-if="scope.row.status == 1">
                <el-tag type="danger">格式错误</el-tag>
              </template>
              <template v-if="scope.row.status == 2">
                <el-tag type="danger">未查询到用户</el-tag>
              </template>
            </template>
          </el-table-column>
          <el-table-column
            label="操作">
            <template slot-scope="scope">
              <el-button size="small" plain @click="onClickRemoveBtn(scope.$index)">移出</el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-row>
      <el-row>
          <el-button style="margin-top: 12px;" type="primary" @click="publish" :loading="loading">确定</el-button>
      </el-row>
  
    </el-card>
  </div>
</template>

<script>
import { BaseVue } from "@/mixin/index";
import { saveApi } from "@/api/module/supplementscore/supplementscore";

export default {
  name: "SupplementScore",
  
  mixins: [BaseVue],
  
  components: {
    // 组件注册
  },
  
  data() {
    return {
      loading: false,
      datas: [],
      attachmentUrl: "http://wkt.shsports.cn/static/file/%E8%A1%A5%E5%85%85%E5%AD%A6%E6%97%B6%E6%A8%A1%E6%9D%BF.xls"
    };
  },
  
  methods: {
    // 发布
    publish() {
      this.loading = true;
      // this.status = "0";

      if(!this.datas || this.datas.length == 0){
        this.$message.error("未获得导入数据");
        this.loading = false;
        return;
      }

      saveApi(this.datas)
        .then(() => {
          this.$message.success("导入成功！");
          this.datas = [];
        })
        .finally(() => {
          this.loading = false;
        });
    },
    
    // 图片上传
    onUploadSuccess(response, file, fileList) {
      console.log("onUploadSuccess", response);

      if(response.success){
          this.$message.info("文件处理完成");
          this.datas = response.data;
      } else {
        this.$message.error("文件处理失败,请对照模板文件检查格式是否正确。");
      }
    },
    
    onBeforeUpload(file) {
      this.$message.info("文件已上传，请稍等");
    },
    
    onClickRemoveBtn(index) {
      this.datas.splice(index, 1);
    },
    
    downloadTemplate() {
      let filename = "补充学时模板.xls";
      let url = "http://wkt.shsports.cn/static/file/%E8%A1%A5%E5%85%85%E5%AD%A6%E6%97%B6%E6%A8%A1%E6%9D%BF.xls";
      let link = document.createElement("a");
      link.style.display = "none";
      link.href = url;
      link.setAttribute("download", filename);
      document.body.appendChild(link);
      link.click();
    }
  },
  
  mounted() {
    // console.log(this.roleid);
  }
};
</script>

<style scoped lang="scss">

</style>

